import API from "../../../app/api";

export const getCustomers = async ({ dealerId, q, type }) => {
  try {
    const response = await API.get("/customers", {
      params: {
        dealerId,   // keep if backend still needs it
        q,          // search keyword (e.g. "env")
        type        // type filter
      },
    });

    if (response.data?.success) {
      return response.data.data || [];
    }

    return [];
  } catch (error) {
    console.log(error);
    return [];
  }
};